/**
 * `missionId` in /drones?... is set on navigate from checklist/take-off; it becomes stale after mission end
 * but often stays in the address bar. Never drive the map from it while the drone is IDLE, or when it
 * disagrees with the mission id from the live drone payload.
 */
export function urlMissionIdForDronesRoute(
  isDroneIdle: boolean,
  missionIdFromSearchParams: string | null,
  trustedMissionIdFromDrone: string | undefined
): string | null {
  if (isDroneIdle) return null;
  if (!missionIdFromSearchParams) return null;
  if (
    trustedMissionIdFromDrone &&
    missionIdFromSearchParams !== trustedMissionIdFromDrone
  ) {
    return null;
  }
  return missionIdFromSearchParams;
}
